export interface VaultConfig {
  displayName: string
  supportsAutoCompound: boolean
  routerType: 'island' | 'v2' | 'charm'
  transactionLabels: {
    addLiquidity: string
    depositOnly: string
    withStaking: string
  }
}

export const ISLAND_CONFIG: VaultConfig = {
  displayName: 'Island',
  supportsAutoCompound: true,
  routerType: 'island',
  transactionLabels: {
    addLiquidity: 'Add Liquidity to Island',
    depositOnly: 'Deposit Only',
    withStaking: 'With Staking',
  },
}

export const CHARMVAULT_CONFIG: VaultConfig = {
  displayName: 'CharmVault',
  supportsAutoCompound: true,
  routerType: 'charm',
  transactionLabels: {
    addLiquidity: 'Add Liquidity to CharmVault',
    depositOnly: 'Deposit Only',
    withStaking: 'With Staking',
  },
}

export const V2_CONFIG: VaultConfig = {
  displayName: 'V2 Pool',
  supportsAutoCompound: false,
  routerType: 'v2',
  transactionLabels: {
    addLiquidity: 'Add Liquidity to V2 Pool',
    depositOnly: 'Deposit Only',
    withStaking: 'With Staking',
  },
}

export const VAULT_CONFIGS = {
  island: ISLAND_CONFIG,
  charmvault: CHARMVAULT_CONFIG,
  v2: V2_CONFIG,
} as const
